<template>
	<div class="container">
		<van-sticky>
			<navbar :title="title" />
		</van-sticky>

		<van-button class="add-button" icon="plus" type="info" round @click="addFllow" />

		<van-cell
			@click="followDetails(item.client_id)"
			v-for="(item, index) in list.follow"
			:key="index"
		>
			<div class="user-title">
				<span class="user-title-name" style="font-weight: 600;">
					<van-icon name="friends-o" />
					{{item.user_name}}
				</span>
				<span class="user-title-date" style="float: right; font-size: 12px;">{{item.date.slice(0, 10)}}</span>
			</div>
			<div class>
				<van-icon name="logistics" />
				{{list.follow_way[item.follow_way].text}}
			</div>
			<div class>
				<van-icon name="records" />
				{{item.follow_content}}
			</div>
		</van-cell>

		<!-- <van-tabbar v-model="activeName">
			<van-tabbar-item name="list" icon="user-o" to="/customer/list">我的客户</van-tabbar-item>
			<van-tabbar-item name="public" icon="friends-o" to="/customer/publicList">公共客户</van-tabbar-item>
			<van-tabbar-item name="index" icon="add-o" to="/customer/index">新增客户</van-tabbar-item>
		</van-tabbar>-->

		<van-popup v-model="popup.add" round closeable :style="{ width: '80%' }">
			<van-form @submit="onSubmit" style="margin-top: 30px;">
				<van-field
					v-model="form.follow_way_text"
					name="跟进方式"
					label="跟进方式"
					placeholder="请选择跟进方式"
					readonly
					@click="picker.wayPicker = true"
				/>
				<van-field
					v-model="form.client_status_text"
					name="客户状态"
					label="客户状态"
					placeholder="请选择客户状态"
					readonly
					@click="picker.statusPicker = true"
				/>
				<van-field
					v-model="form.follow_content"
					rows="3"
					autosize
					label="备注"
					type="textarea"
					placeholder="请输入备注"
					:rules="[{ required: true, message: '请填写备注' }]"
				/>
				<div style="margin: 16px;">
					<van-button round block type="info" native-type="submit">提交</van-button>
				</div>
			</van-form>
		</van-popup>

		<van-popup v-model="picker.wayPicker" position="bottom">
			<van-picker
				show-toolbar
				:columns="list.follow_way"
				@cancel="picker.wayPicker = false"
				@confirm="confirmWay"
			/>
		</van-popup>
		<van-popup v-model="picker.statusPicker" position="bottom">
			<van-picker
				show-toolbar
				:columns="list.client_status"
				@cancel="picker.statusPicker = false"
				@confirm="confirmStatus"
			/>
		</van-popup>
	</div>
</template>

<script>
import navbar from "@/components/navBar/index";
import { customer, addFollow } from "@/api/customer";
import { Toast } from "vant";

export default {
	name: "customer",
	components: {
		navbar
	},
	data() {
		return {
			title: "客户跟进",
			activeName: "list",
			popup: {
				add: false
			},
			picker: {
				statusPicker: false,
				wayPicker: false
			},
			form: {
				requestType: "client_follow_details",
				client_id: this.$route.query.id,
				follow_way: "",
				follow_way_text: "",
				client_status: this.$route.query.client_status,
				client_status_text: "",
				follow_content: ""
			},
			list: {
				follow: [],
				loading: false,
				finished: false,
				search: "",
				follow_way: [
					{ text: "电话联系", id: 0 },
					{ text: "社交软件", id: 1 },
					{ text: "上门拜访", id: 2 }
				],
				client_status: [
					{ text: "意向客户", id: 0 },
					{ text: "现场确认尺寸和方案", id: 1 },
					{ text: "已做报价及方案", id: 2 },
					{ text: "需要配合招投标", id: 3 },
					{ text: "待签订合同", id: 4 },
					{ text: "已签订合同", id: 5 },
					{ text: "跟单失败客户", id: 6 }
				]
			}
		};
	},
	mounted() {
		this.getCustomer();
	},
	methods: {
		getCustomer() {
			customer({
				requestType: "client_follow_list",
				client_id: this.form.client_id
			})
				.then(res => {
					this.list.follow = res.obj.follow;
				})
				.catch(() => {
					Toast.fail("服务器发生错误");
				});
		},
		followDetails() {},
		addFllow() {
			this.popup.add = true;
		},
		onSubmit() {
			if (!this.form.follow_way_text) {
				return Toast.fail("请选择跟进方式");
			}
			if (!this.form.client_status_text) {
				return Toast.fail("请选择客户状态");
			}
			if (!this.form.follow_content) {
				return Toast.fail("请填写备注");
			}

			addFollow(this.form)
				.then(() => {
					this.getCustomer();
					Toast.success("跟进成功!");
					this.form.follow_way_text = "";
					this.form.client_status_text = "";
					this.form.follow_content = "";
					this.popup.add = false;
				})
				.catch(() => {
					Toast.fail("数据异常");
					this.popup.add = false;
				});
		},
		confirmWay(value) {
			this.form.follow_way_text = value.text;
			this.form.follow_way = value.id;
			this.picker.wayPicker = false;
		},
		confirmStatus(value) {
			this.form.client_status_text = value.text;
			this.form.client_status = value.id;
			this.picker.statusPicker = false;
		}
	}
};
</script>

<style scoped>
.add-button {
	position: fixed;
	bottom: 50px;
	right: 50px;
	width: 46px;
	height: 46px;
	display: flex;
	align-items: center;
	justify-content: center;
}
</style>
